// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"header_logoLink__Y2Ig6"};